<template>
    <div style="border-radius: 4px;border: 1px solid #D9E4F8;padding:24px;display: flex;align-items: center;">
        <div style="flex: 1;font-size: 12px;color: #0E193B;">{{ title }}</div>
        <div style="font-size: 16px;font-weight: bold;color: #0E193B;">{{ value }}</div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '行驶里程(km)'
        },
        value: {
            type:Number,
            default:0
        }
    },
}
</script>